module.exports = __webpack_public_path__ + "static/media/guy-mentor.bab437b6.jpg";